
































































































import { Component, Vue } from "vue-property-decorator";
import { messagesCollection, Timestamp } from "../db";
import { MetaInfo } from "vue-meta";

@Component({
  components: {},
  metaInfo(): MetaInfo {
    return {
      title: "Contact Us",
    };
  },
})
export default class Contact extends Vue {
  private dialogThanks = false;

  private formData = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
    read: false,
    created: Timestamp.now(),
  };

  openStorage() {
    const result = JSON.parse(localStorage.getItem("contactForm") || "{}");
    const fields = ["firstName", "lastName", "phone", "email"];
    fields.forEach((x) => {
      this.updateForm(x, result);
    });
  }

  updateForm(field, data) {
    if (data[field]) {
      this.formData[field] = data[field];
    }
  }

  saveStorage() {
    localStorage.setItem("contactForm", JSON.stringify(this.formData));
  }

  mounted() {
    this.openStorage();

    const parameters = this.$route.query;
    if (parameters.stockNumber && parameters.name) {
      this.formData.subject = `Interest in #${parameters.stockNumber} ${parameters.name}`;
    }
  }

  async summit() {
    const isValid = await (this.$refs.contactForm as any).validate();
    if (isValid) {
      await messagesCollection.add(this.formData);
      this.dialogThanks = true;
      this.saveStorage();
    }
  }
  dialogClose() {
    this.dialogThanks = false;
    this.$router.go(-1);
  }
}
